import { useDetachedViewTracker } from "@org-avp/avp-avengers-ui-shared-store";
import { ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC } from "react";

export const DetachedView: FC<{ view: ViewModule }> = ({ view }) => {
  useDetachedViewTracker(view.viewKey);

  return (
    <div style={{ height: "100vh" }}>
      {view.viewEl}
    </div>
  );
};
